import { render, staticRenderFns } from "./NodePopupQuiz.vue?vue&type=template&id=690e1d0b"
import script from "./NodePopupQuiz.vue?vue&type=script&lang=js"
export * from "./NodePopupQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports